import React, { useState } from "react";
import {
    TextField,
    Button,
    Grid,
    IconButton,
    Divider,
    Box,
    Alert,
} from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import authService from "../Auth/AuthService";

const EntryCardForm = ({ entryCard, onSuccess }) => {

    const navigate = useNavigate();
    const [form, setForm] = useState([
        { subject: "", days: "", examDate: "" }
    ]);
    const [notes, setNotes] = useState({
        note: "The admit card is essential and must be carried to the exam centre. Candidates may also need to carry a valid photo ID proof for written, oral, and signal examinations."
    });

    const getDayName = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", { weekday: "long" });
    };

    const handleMarkChange = (index, e) => {
        const updated = [...form];
        updated[index][e.target.name] = e.target.value;

        if (e.target.name === "examDate") {
            updated[index].days = getDayName(e.target.value);
        }
        setForm(updated);
    };

    const addSubject = () => {
        setForm([...form, { subject: "", days: "", examDate: "" }]);
    };

    const removeSubject = (index) => {
        const updated = form.filter((_, i) => i !== index);
        setForm(updated);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        sessionStorage.setItem("hide", false);
        try {
            // const url = authService.pathUrl('POST', '/entry-card/bulk')
            // await authService.postAuth(url, form);
            if (onSuccess) onSuccess();
            navigate('/entry-card', {
                state: {
                    students: entryCard, ...notes,
                    entryList: form,
                }
            })
        } catch (error) {
            console.error(error);
            alert("saving entry Card " + error);
        }
    };

    const handleChange = (e) => {
        setNotes({ ...notes, [e.target.name]: e.target.value });
    };

    return (
        <Box>
            <form onSubmit={handleSubmit}>
                <Grid item xs={12} mb={2}>
                    <TextField
                        required
                        label="Notes"
                        name="note"
                        value={notes.note}
                        onChange={handleChange}
                        fullWidth
                        multiline
                    />
                </Grid>
                <Divider sx={{ mb: 3 }} />
                {form.map((mark, index) => (
                    <Grid container spacing={2} mb={2} alignItems="center" key={index}>
                        <Grid item xs={3}>
                            <TextField
                                required
                                label="Subject"
                                name="subject"
                                value={mark.subject}
                                onChange={(e) => handleMarkChange(index, e)}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                required
                                label="Day"
                                name="days"
                                value={mark.days}
                                onChange={(e) => handleMarkChange(index, e)}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                required
                                label="Exam Date"
                                name="examDate"
                                type="date"
                                slotProps={{
                                    inputLabel: { shrink: true }
                                }}
                                value={mark.examDate}
                                onChange={(e) => handleMarkChange(index, e)}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={1}>
                            <IconButton color="error" onClick={() => removeSubject(index)}>
                                <RemoveCircle />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}

                <Button
                    startIcon={<AddCircle />}
                    onClick={addSubject}
                    sx={{ mt: 2, color: "#1b1914", fontWeight: "bold" }}
                >
                    Add Subject
                </Button>

                <Button
                    type="submit"
                    variant="contained"
                    sx={{ mt: 3, ml: 2, bgcolor: "#1b1914", borderRadius: 5 }}
                >
                    Create Card
                </Button>
            </form>
        </Box>
    );
};

export default EntryCardForm;
